// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2x4Kd","colMaxWidth":"Table_colMaxWidth__1ieJ1"};